// extracted by mini-css-extract-plugin
export default {"button":"styles_button__LXQds","focus":"styles_focus__mZbGm","stopRecording":"styles_stopRecording__HkaVf"};